const Order = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC'
})
export default Order
// RESERVE BELOW
